import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input, Select } from "../../../components/form";
import { Button } from "../../../components/button";
import { useProducts } from "../../products/hooks";
import { useWarehouses } from "../../warehouses/hooks";

interface IStockUnitForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const StockUnitForm: React.FC<IStockUnitForm> = ({
  loading,
  form,
  submit,
}) => {
  const { data: productsData } = useProducts({ where: {}, limit: 100, offset: 0 });
  const { data: warehousesData } = useWarehouses({ where: {} });

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Select
          label="Produit"
          className="w-full"
          value={form.watch("productId") ?? ""}
          {...form.register("productId", { required: true, valueAsNumber: true })}
        >
          <option value="">-</option>
          {productsData?.products?.results?.map((product) => (
            <option key={product.id} value={product.id}>
              {product.name}
            </option>
          ))}
        </Select>
        <Select
          label="Entrepôt"
          className="w-full"
          value={form.watch("warehouseId") ?? ""}
          {...form.register("warehouseId", { required: true, valueAsNumber: true })}
        >
          <option value="">-</option>
          {warehousesData?.warehouses?.results?.map((warehouse) => (
            <option key={warehouse.id} value={warehouse.id}>
              {warehouse.name}
            </option>
          ))}
        </Select>
        <Input
          label="Numéro de lot"
          className="w-full"
          {...form.register("batchNumber", { required: "Numéro de lot requis" })}
        />
        <Input
          label="Quantité"
          type="number"
          className="w-full"
          {...form.register("quantity", { required: true, valueAsNumber: true })}
        />
        <Input
          label="Date de réception"
          type="date"
          className="w-full"
          value={form.watch("enteredAt") ?? ""}
          {...form.register("enteredAt", { required: true })}
        />
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Continuer vers le scan
        </Button>
      </div>
    </div>
  );
};
